export default __webpack_public_path__ + "static/media/MACS-Logo.997fbfd4.svg";